import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Typography, Button, Box, IconButton, Tooltip,
} from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import EditIcon from '@material-ui/icons/Edit';
import EditLocationIcon from '@material-ui/icons/EditLocation';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 12,
  },
  title: {
    fontSize: 14,
    fontWeight: 500,
    flex: 1,
  },
  addBtn: {
    textTransform: 'none',
    fontSize: 12,
    padding: '4px 10px',
  },
  area: {
    padding: '10px 12px',
    borderLeft: '3px dotted #f28c00',
    background: '#fff8df',
    borderRadius: 4,
    marginBottom: 6,
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  areaName: {
    flex: 1,
    fontSize: 13,
    fontWeight: 500,
    color: '#333',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  emptyBox: {
    padding: 20,
    background: '#f5f5f5',
    borderRadius: 6,
    textAlign: 'center',
    fontSize: 12,
    color: '#999',
  },
}));

const ServiceAreasSection = ({
  areas = [],
  onDraw,
  onEditShape,
  onDelete,
  onRename,
  drawing,
  editing,
  disabled,
}) => {
  const classes = useStyles();

  return (
    <Box>
      <div className={classes.header}>
        <RoomIcon style={{ fontSize: 18, color: '#666' }} />
        <Typography className={classes.title}>Service areas</Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={onDraw}
          className={classes.addBtn}
          startIcon={<AddIcon style={{ fontSize: 14 }} />}
          disabled={disabled || drawing}
        >
          {drawing ? 'Drawing...' : 'Add'}
        </Button>
      </div>

      {areas.length === 0 ? (
        <div className={classes.emptyBox}>
          None defined
          <div style={{ fontSize: 11, marginTop: 4 }}>
            Draw where you actually service this property, if different from the boundary
          </div>
        </div>
      ) : (
        <Box>
          {areas.map((sa) => (
            <div key={sa._id} className={classes.area}>
              <span className={classes.areaName}>{sa.name || 'Service Area'}</span>
              <Tooltip title="Edit shape">
                <IconButton
                  size="small"
                  onClick={() => onEditShape(sa)}
                  style={{ padding: 2 }}
                  disabled={editing || drawing}
                >
                  <EditLocationIcon style={{ fontSize: 14, color: '#ff9800' }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Rename">
                <IconButton
                  size="small"
                  onClick={() => {
                    const newName = window.prompt('Rename service area:', sa.name || '');
                    if (newName && newName.trim()) onRename(sa._id, newName.trim());
                  }}
                  style={{ padding: 2 }}
                >
                  <EditIcon style={{ fontSize: 14 }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  size="small"
                  onClick={() => {
                    if (window.confirm(`Delete "${sa.name || 'this service area'}"?`)) {
                      onDelete(sa._id);
                    }
                  }}
                  style={{ padding: 2 }}
                >
                  <DeleteIcon style={{ fontSize: 14, color: '#999' }} />
                </IconButton>
              </Tooltip>
            </div>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default ServiceAreasSection;
